<div class="hmd-btn dict-form-btn">
  <template v-if="isEdit">
    <hmd-empty-link v-if="!showAddUnit" @click="showEditModal">编辑</hmd-empty-link>
  </template>
  <template v-else>
    <a-button v-if="!showAddUnit" type="primary" @click="showCreateModal">新建</a-button>
  </template>

  <a-modal
    v-model:visible="visible"
    :confirm-loading="createLoading || editLoading"
    :keyboard="false"
    :centered="true"
    :mask-closable="false"
    :zIndex="1200"
    @ok="submit"
    @cancel="closeModal"
  >
    <template #title>{{ isEdit ? "编辑" : "新建" }}结算单位</template>
    <a-skeleton :loading="detailLoading" active>
      <a-form layout="vertical">
        <a-form-item label="结算单位名称" v-bind="validateInfos.name">
          <a-input v-model:value.trim="formRef.name" placeholder="请输入中文名称" :maxlength="10">
            <template #suffix>
              <span class="text-grey">{{ formRef.name.length }}/10</span>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item label="单位符号" v-bind="validateInfos.symbol">
          <a-input v-model:value.trim="formRef.symbol" placeholder="请输入单位符号" :maxlength="10">
            <template #suffix>
              <span class="text-grey">{{ formRef.symbol.length }}/10</span>
            </template>
          </a-input>
        </a-form-item>
      </a-form>
    </a-skeleton>
  </a-modal>
</div>
